export const scrollToTextContent = (text_content) => {
  // Find the target element with the specific text content
  const elements = document.querySelectorAll(".chakra-text.css-5wqpls");

  // Loop through the elements and find the one with the desired text
  let targetElement = null;
  for (const element of elements) {
    if (element.textContent === text_content) {
      targetElement = element;
      break;
    }
  }

  if (targetElement) {
    const offset = window.innerHeight * 0.15; // 15vh
    window.scrollTo({
      top: targetElement.getBoundingClientRect().top + window.scrollY - offset,
      behavior: "smooth",
    });
  }
};
